// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./HTML/Montserrat-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./HTML/Montserrat-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./HTML/Montserrat-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./HTML/Bebas Neue_bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./HTML/Audiowide-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Montserrat Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}
@font-face {
  font-family: 'Montserrat Bold Italic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}
@font-face {
  font-family: 'Montserrat Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}
@font-face {
  font-family: 'Bebas Neue';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
}
@font-face {
  font-family: 'Audiowide';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
}

:root {
  --orange: #ff5722;
  --white: #ffffff;
}

* { box-sizing: border-box; }

/* ── Обёртка ──────────────────────────────────────────── */
.pd-wrap {
  min-height: 100vh;
  display: grid;
  place-items: center;
  background: #0a0a14;
}

.pd-loading {
  min-height: 100vh;
  display: grid;
  place-items: center;
  background: #0a0a14;
  color: white;
  font-family: Montserrat, system-ui, Arial, sans-serif;
}

/* ── Холст ─────────────────────────────────────────────── */
.canvas {
  width: 1920px;
  height: 1080px;
  position: relative;
  overflow: hidden;
  /* Цвет фона меняется через inline style + CSS transition */
  transition: background 2s ease;
  transform-origin: center;
  scale: 1;
}

/* Смена сотрудника — только opacity, без transform */
.canvas.fading .photo-card,
.canvas.fading .internal,
.canvas.fading .big-number,
.canvas.fading .name-block,
.canvas.fading .position,
.canvas.fading .company-box,
.canvas.fading .bottom-info {
  opacity: 0.15;
}

/* ── PNG линии справа ───────────────────────────────────── */
.lines-image {
  position: absolute;
  right: 0;
  top: 0;
  width: auto;
  height: 100%;
  pointer-events: none;
  z-index: 2;
  opacity: .6;
}

/* ── Фото ───────────────────────────────────────────────── */
.photo-card {
  position: absolute;
  left: 150px;
  top: 150px;
  width: 600px;
  height: 600px;
  border-radius: 30px;
  overflow: hidden;
  background: #0a0a0a;
  box-shadow: 0 22px 60px rgba(0,0,0,.5);
  z-index: 10;
  transition: opacity 0.4s ease;
}

.photo-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.photo-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-size: 120px;
  font-weight: bold;
}

/* ── Метка внутренний ───────────────────────────────────── */
.internal {
  position: absolute;
  left: 182px;
  bottom: 380px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: 'Bebas Neue', sans-serif;
  font-size: 30px;
  letter-spacing: .5px;
  text-transform: uppercase;
  color: var(--orange);
  z-index: 15;
  transition: opacity 0.4s ease;
}

/* ── Номер ──────────────────────────────────────────────── */
.big-number {
  position: absolute;
  left: 176px;
  bottom: 172px;
  font-family: 'Audiowide', sans-serif;
  font-size: 250px;
  line-height: 1;
  letter-spacing: -8px;
  color: var(--white);
  z-index: 15;
  transition: opacity 0.4s ease;
}

/* ── Имя ────────────────────────────────────────────────── */
.name-block {
  font-family: 'Montserrat Bold';
  position: absolute;
  left: 530px;
  top: 120px;
  width: 1260px;
  height: 220px;
  border: 3px solid var(--orange);
  border-radius: 8px;
  overflow: visible;
  z-index: 8;
  transition: opacity 0.4s ease;
}

.name-block::before {
  content: "";
  position: absolute;
  top: 0;
  width: 310px;
  height: 100%;
  background: var(--orange);
  z-index: -1;
}

.name-block .name {
  position: relative;
  z-index: 1;
  margin: 0;
  padding: 28px 200px 0 340px;
  font-weight: 800;
  font-size: 68px;
  letter-spacing: 1.2px;
  color: var(--white);
}

.user-status-emoji {
  position: absolute;
  right: 36px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 100px;
  line-height: 1;
  opacity: 0.92;
}

.name-block .fullname {
  position: relative;
  z-index: 1;
  margin: 0 0 0 340px;
  font-weight: 600;
  font-size: 38px;
  color: rgba(255,255,255,.95);
}

/* ── Должность ──────────────────────────────────────────── */
.position {
  font-family: 'Montserrat Bold Italic';
  position: absolute;
  left: 843px;
  top: 340px;
  padding: 12px 36px 14px;
  background: var(--orange);
  border-radius: 0 0 6px 6px;
  font-weight: 800;
  font-style: italic;
  font-size: 30px;
  color: var(--white);
  z-index: 20;
  transition: opacity 0.4s ease;
}

/* ── Компания ───────────────────────────────────────────── */
.company-box {
  position: absolute;
  left: 875px;
  top: 495px;
  z-index: 20;
  transition: opacity 0.4s ease;
}

.brand-line {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
}

.company-box .company-name {
  font-family: 'Montserrat Bold';
  margin: 0;
  font-weight: 800;
  font-size: 54px;
  letter-spacing: .4px;
  color: var(--white);
}

.company-box .city {
  font-family: 'Montserrat Regular';
  margin: 6px 0 0;
  font-size: 26px;
  color: rgba(255,255,255,.82);
}

/* ── Нижний блок ────────────────────────────────────────── */
.bottom-info {
  position: absolute;
  left: 875px;
  top: 710px;
  display: grid;
  grid-template-columns: 320px 1fr;
  max-width: 900px;
  z-index: 20;
  align-items: start;
  transition: opacity 0.4s ease;
}

.bottom-info > div {
  display: flex;
  flex-direction: column;
}

.info-label {
  font-family: 'Montserrat Bold';
  margin: 0 0 16px;
  font-weight: 800;
  font-size: 30px;
  line-height: 1;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: #ff9966;
}

.years-text {
  font-family: 'Montserrat Bold';
  font-weight: 800;
  font-size: 48px;
  line-height: 1;
  letter-spacing: -1px;
  color: var(--white);
}

.years-text .small {
  font-weight: 700;
  font-size: 26px;
  color: rgba(255,255,255,.92);
}

.skills-text {
  font-family: 'Montserrat Regular';
  font-size: 20px;
  line-height: 1.5;
  color: rgba(255,255,255,.8);
}

/* ── Стрип статусов (3 строки, выровненные эмодзи) ─────── */
.status-strip {
  position: absolute;
  bottom: 14px;
  left: 20px;
  right: 20px;
  /* 4 × 24px + 3 × 5px gap + 6px + 6px padding = 123px */
  height: 123px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: 5px 4px;
  padding: 6px 14px;
  background: rgba(0,0,0,0.5);
  border-radius: 8px;
  z-index: 30;
  overflow: hidden;
}

/* Каждая карточка — фиксированная ширина, чтобы колонки не плыли */
.status-card {
  display: flex;
  align-items: center;
  gap: 5px;
  width: 210px;
  height: 24px;
  flex-shrink: 0;
}

/* Эмодзи — слева, фиксированная ширина */
.sc-emoji {
  font-size: 15px;
  line-height: 1;
  width: 20px;
  flex-shrink: 0;
}

/* Номер телефона */
.sc-phone {
  font-family: 'Montserrat Regular', sans-serif;
  font-size: 13px;
  color: rgba(255,255,255,0.55);
  width: 26px;
  flex-shrink: 0;
  line-height: 1;
}

/* Сокращённое имя + фамилия */
.sc-name {
  font-family: 'Montserrat Regular', sans-serif;
  font-size: 13px;
  color: rgba(255,255,255,0.92);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
  line-height: 1;
}

.sc-loading {
  color: rgba(255,255,255,0.35);
  font-family: 'Montserrat Regular', sans-serif;
  font-size: 16px;
  align-self: center;
}

/* ── Адаптив ────────────────────────────────────────────── */
@media (max-width: 1920px) {
  .canvas { scale: calc(100vw / 1920); }
}

@media (max-height: 1080px) {
  .canvas { scale: min(calc(100vw / 1920), calc(100vh / 1080)); }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PublicDashboard.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,+DAAyD;AAC3D;AACA;EACE,qCAAqC;EACrC,+DAA+D;AACjE;AACA;EACE,iCAAiC;EACjC,+DAA4D;AAC9D;AACA;EACE,yBAAyB;EACzB,+DAAyD;AAC3D;AACA;EACE,wBAAwB;EACxB,+DAA2D;AAC7D;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,IAAI,sBAAsB,EAAE;;AAE5B,4DAA4D;AAC5D;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,qDAAqD;AACvD;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,2DAA2D;EAC3D,8BAA8B;EAC9B,wBAAwB;EACxB,QAAQ;AACV;;AAEA,qDAAqD;AACrD;;;;;;;EAOE,aAAa;AACf;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,WAAW;AACb;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,oBAAoB;EACpB,WAAW;EACX,6BAA6B;AAC/B;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,6BAA6B;AAC/B;;AAEA,8DAA8D;AAC9D;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,aAAa;EACb,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA,8DAA8D;AAC9D;EACE,qCAAqC;EACrC,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,6BAA6B;AAC/B;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,uDAAuD;EACvD,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,6CAA6C;EAC7C,eAAe;EACf,6BAA6B;EAC7B,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,6CAA6C;EAC7C,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;AACpB;;AAEA,8DAA8D;AAC9D;EACE,UAAU,yBAAyB,EAAE;AACvC;;AAEA;EACE,UAAU,kDAAkD,EAAE;AAChE","sourcesContent":["@font-face {\n  font-family: 'Montserrat Bold';\n  src: url('./HTML/Montserrat-Bold.ttf') format('truetype');\n}\n@font-face {\n  font-family: 'Montserrat Bold Italic';\n  src: url('./HTML/Montserrat-BoldItalic.ttf') format('truetype');\n}\n@font-face {\n  font-family: 'Montserrat Regular';\n  src: url('./HTML/Montserrat-Regular.ttf') format('truetype');\n}\n@font-face {\n  font-family: 'Bebas Neue';\n  src: url('./HTML/Bebas Neue_bold.ttf') format('truetype');\n}\n@font-face {\n  font-family: 'Audiowide';\n  src: url('./HTML/Audiowide-Regular.ttf') format('truetype');\n}\n\n:root {\n  --orange: #ff5722;\n  --white: #ffffff;\n}\n\n* { box-sizing: border-box; }\n\n/* ── Обёртка ──────────────────────────────────────────── */\n.pd-wrap {\n  min-height: 100vh;\n  display: grid;\n  place-items: center;\n  background: #0a0a14;\n}\n\n.pd-loading {\n  min-height: 100vh;\n  display: grid;\n  place-items: center;\n  background: #0a0a14;\n  color: white;\n  font-family: Montserrat, system-ui, Arial, sans-serif;\n}\n\n/* ── Холст ─────────────────────────────────────────────── */\n.canvas {\n  width: 1920px;\n  height: 1080px;\n  position: relative;\n  overflow: hidden;\n  /* Цвет фона меняется через inline style + CSS transition */\n  transition: background 2s ease;\n  transform-origin: center;\n  scale: 1;\n}\n\n/* Смена сотрудника — только opacity, без transform */\n.canvas.fading .photo-card,\n.canvas.fading .internal,\n.canvas.fading .big-number,\n.canvas.fading .name-block,\n.canvas.fading .position,\n.canvas.fading .company-box,\n.canvas.fading .bottom-info {\n  opacity: 0.15;\n}\n\n/* ── PNG линии справа ───────────────────────────────────── */\n.lines-image {\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: auto;\n  height: 100%;\n  pointer-events: none;\n  z-index: 2;\n  opacity: .6;\n}\n\n/* ── Фото ───────────────────────────────────────────────── */\n.photo-card {\n  position: absolute;\n  left: 150px;\n  top: 150px;\n  width: 600px;\n  height: 600px;\n  border-radius: 30px;\n  overflow: hidden;\n  background: #0a0a0a;\n  box-shadow: 0 22px 60px rgba(0,0,0,.5);\n  z-index: 10;\n  transition: opacity 0.4s ease;\n}\n\n.photo-card img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.photo-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  font-size: 120px;\n  font-weight: bold;\n}\n\n/* ── Метка внутренний ───────────────────────────────────── */\n.internal {\n  position: absolute;\n  left: 182px;\n  bottom: 380px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-family: 'Bebas Neue', sans-serif;\n  font-size: 30px;\n  letter-spacing: .5px;\n  text-transform: uppercase;\n  color: var(--orange);\n  z-index: 15;\n  transition: opacity 0.4s ease;\n}\n\n/* ── Номер ──────────────────────────────────────────────── */\n.big-number {\n  position: absolute;\n  left: 176px;\n  bottom: 172px;\n  font-family: 'Audiowide', sans-serif;\n  font-size: 250px;\n  line-height: 1;\n  letter-spacing: -8px;\n  color: var(--white);\n  z-index: 15;\n  transition: opacity 0.4s ease;\n}\n\n/* ── Имя ────────────────────────────────────────────────── */\n.name-block {\n  font-family: 'Montserrat Bold';\n  position: absolute;\n  left: 530px;\n  top: 120px;\n  width: 1260px;\n  height: 220px;\n  border: 3px solid var(--orange);\n  border-radius: 8px;\n  overflow: visible;\n  z-index: 8;\n  transition: opacity 0.4s ease;\n}\n\n.name-block::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  width: 310px;\n  height: 100%;\n  background: var(--orange);\n  z-index: -1;\n}\n\n.name-block .name {\n  position: relative;\n  z-index: 1;\n  margin: 0;\n  padding: 28px 200px 0 340px;\n  font-weight: 800;\n  font-size: 68px;\n  letter-spacing: 1.2px;\n  color: var(--white);\n}\n\n.user-status-emoji {\n  position: absolute;\n  right: 36px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 100px;\n  line-height: 1;\n  opacity: 0.92;\n}\n\n.name-block .fullname {\n  position: relative;\n  z-index: 1;\n  margin: 0 0 0 340px;\n  font-weight: 600;\n  font-size: 38px;\n  color: rgba(255,255,255,.95);\n}\n\n/* ── Должность ──────────────────────────────────────────── */\n.position {\n  font-family: 'Montserrat Bold Italic';\n  position: absolute;\n  left: 843px;\n  top: 340px;\n  padding: 12px 36px 14px;\n  background: var(--orange);\n  border-radius: 0 0 6px 6px;\n  font-weight: 800;\n  font-style: italic;\n  font-size: 30px;\n  color: var(--white);\n  z-index: 20;\n  transition: opacity 0.4s ease;\n}\n\n/* ── Компания ───────────────────────────────────────────── */\n.company-box {\n  position: absolute;\n  left: 875px;\n  top: 495px;\n  z-index: 20;\n  transition: opacity 0.4s ease;\n}\n\n.brand-line {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 6px;\n}\n\n.company-box .company-name {\n  font-family: 'Montserrat Bold';\n  margin: 0;\n  font-weight: 800;\n  font-size: 54px;\n  letter-spacing: .4px;\n  color: var(--white);\n}\n\n.company-box .city {\n  font-family: 'Montserrat Regular';\n  margin: 6px 0 0;\n  font-size: 26px;\n  color: rgba(255,255,255,.82);\n}\n\n/* ── Нижний блок ────────────────────────────────────────── */\n.bottom-info {\n  position: absolute;\n  left: 875px;\n  top: 710px;\n  display: grid;\n  grid-template-columns: 320px 1fr;\n  max-width: 900px;\n  z-index: 20;\n  align-items: start;\n  transition: opacity 0.4s ease;\n}\n\n.bottom-info > div {\n  display: flex;\n  flex-direction: column;\n}\n\n.info-label {\n  font-family: 'Montserrat Bold';\n  margin: 0 0 16px;\n  font-weight: 800;\n  font-size: 30px;\n  line-height: 1;\n  letter-spacing: 1.2px;\n  text-transform: uppercase;\n  color: #ff9966;\n}\n\n.years-text {\n  font-family: 'Montserrat Bold';\n  font-weight: 800;\n  font-size: 48px;\n  line-height: 1;\n  letter-spacing: -1px;\n  color: var(--white);\n}\n\n.years-text .small {\n  font-weight: 700;\n  font-size: 26px;\n  color: rgba(255,255,255,.92);\n}\n\n.skills-text {\n  font-family: 'Montserrat Regular';\n  font-size: 20px;\n  line-height: 1.5;\n  color: rgba(255,255,255,.8);\n}\n\n/* ── Стрип статусов (3 строки, выровненные эмодзи) ─────── */\n.status-strip {\n  position: absolute;\n  bottom: 14px;\n  left: 20px;\n  right: 20px;\n  /* 4 × 24px + 3 × 5px gap + 6px + 6px padding = 123px */\n  height: 123px;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  align-content: flex-start;\n  gap: 5px 4px;\n  padding: 6px 14px;\n  background: rgba(0,0,0,0.5);\n  border-radius: 8px;\n  z-index: 30;\n  overflow: hidden;\n}\n\n/* Каждая карточка — фиксированная ширина, чтобы колонки не плыли */\n.status-card {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  width: 210px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n/* Эмодзи — слева, фиксированная ширина */\n.sc-emoji {\n  font-size: 15px;\n  line-height: 1;\n  width: 20px;\n  flex-shrink: 0;\n}\n\n/* Номер телефона */\n.sc-phone {\n  font-family: 'Montserrat Regular', sans-serif;\n  font-size: 13px;\n  color: rgba(255,255,255,0.55);\n  width: 26px;\n  flex-shrink: 0;\n  line-height: 1;\n}\n\n/* Сокращённое имя + фамилия */\n.sc-name {\n  font-family: 'Montserrat Regular', sans-serif;\n  font-size: 13px;\n  color: rgba(255,255,255,0.92);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n  line-height: 1;\n}\n\n.sc-loading {\n  color: rgba(255,255,255,0.35);\n  font-family: 'Montserrat Regular', sans-serif;\n  font-size: 16px;\n  align-self: center;\n}\n\n/* ── Адаптив ────────────────────────────────────────────── */\n@media (max-width: 1920px) {\n  .canvas { scale: calc(100vw / 1920); }\n}\n\n@media (max-height: 1080px) {\n  .canvas { scale: min(calc(100vw / 1920), calc(100vh / 1080)); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
